import env from './environment';

const WHITELISTED_SIZES = [64, 96, 140, 200, 225, 300, 400, 500, 640, 960, 1200, 1600];
const PRODUCTION_DOMAIN = 'i.ebayimg.com';
const STAGING_DOMAIN = 'i.qa.ebayimg.com';
const PATH_SEPARATOR = '/';

export function getImageBaseUrl() {
    const domain = (env.isProd() || env.isPreProd()) ? PRODUCTION_DOMAIN : STAGING_DOMAIN;
    return `https://${domain}`;
}

export function buildImageUrlByZoomId(zoomId, originalSize, format) {
    const baseUrl = getImageBaseUrl();
    const size = WHITELISTED_SIZES.find(wlSize => wlSize >= originalSize);
    return `${baseUrl}/thumbs/images/g/${zoomId}${PATH_SEPARATOR}s-l${size}.${format}`;
}
